import dateFnDifferenceInDays from 'date-fns/differenceInDays'
import toDate, { dateParamType } from '~/utils/gcxDates/toDate'

type getDaysDiffFn = (timeOne: dateParamType, timeTwo: dateParamType) => number
/**
 * @returns number of _whole_ day periods between two times. Fractional days are
 * truncated towards zero
 */
const getDaysDiff: getDaysDiffFn = (timeOne, timeTwo) => {
  const date1 = toDate(timeOne)
  const date2 = toDate(timeTwo)

  return Math.abs(dateFnDifferenceInDays(date2, date1))
}

export default getDaysDiff
